export default [
    ['COMMON', '通用'],
    ['DC', '控件组'],
]
